module.exports = __webpack_public_path__ + "img/DKFT11188.c13327a7.png";